import { SxProps, Theme } from '@mui/material';

export const designTokens = {
    // Glassmorphism Card Style
    glassCard: {
        bgcolor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(20px)',
        borderRadius: 4, // 32px
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        transition: 'all 0.3s ease-in-out',
        overflow: 'hidden',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 12px 40px 0 rgba(31, 38, 135, 0.25)',
        }
    } as SxProps<Theme>,

    // Page Header Style
    pageHeader: {
        mb: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    } as SxProps<Theme>,

    // Page Title Typography
    pageTitle: {
        fontWeight: 700,
        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        textShadow: '0px 2px 4px rgba(0,0,0,0.1)'
    } as SxProps<Theme>,

    // Action Button (Gradient)
    actionButton: {
        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        border: 0,
        borderRadius: 3,
        boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
        color: 'white',
        height: 48,
        padding: '0 30px',
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: '1rem',
        transition: 'all 0.2s',
        '&:hover': {
            transform: 'scale(1.02)',
            boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
        }
    } as SxProps<Theme>,

    // Input Field Style (Rounded)
    input: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            bgcolor: 'rgba(255, 255, 255, 0.5)',
            transition: 'all 0.2s',
            '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.8)',
            },
            '&.Mui-focused': {
                bgcolor: '#fff',
                boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
            }
        }
    } as SxProps<Theme>,

    // Chip/Tag Style
    chip: {
        borderRadius: 2,
        fontWeight: 600,
        boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
    } as SxProps<Theme>,

    // Page Background
    mainBackground: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%)',
    } as SxProps<Theme>,

    // Hero Header Style
    heroHeader: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: 4,
        p: { xs: 3, md: 5 },
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
    } as SxProps<Theme>,
};
